"use strict";
bin.service("BinSummaryService", function(BinFactory, $filter, GradeSetupModelService, DateService, PermissionModelService, authServiceFactory, BinService)
{
    this._filter = "";
    return {
        setFilter: function(grade)
        {
            this._filter = grade;
        },
        inBin: function(value)
        {
            if (BinService.getBin() === "Applications" && value.Status_Unfinished != 1)
                return true;
            else if (BinService.getBin() === "New" && value.Status_New == 1 && value.Status_Unfinished != 1)
                return true;
            else if (BinService.getBin() === "Viewed" && value.Status_Viewed == 1 && value.Status_Unfinished != 1)
                return true;
            else if (BinService.getBin() === "Consider" && value.Status_Consider == 1 && value.Status_Unfinished != 1)
                return true;
            else if (BinService.getBin() === "Award" && value.Status_Award == 1 && value.ActAward > 0 && value.Status_Unfinished != 1)
                return true;
            else if (BinService.getBin() === "Non-Awarded" && (value.Status_Reject == 1 || (value.Status_Award == 1 && value.ActAward == 0)) && value.Status_Unfinished != 1)
                return true;
            else if (BinService.getBin() === "Appealed" && value.Status_Appeal == 1 && value.Status_Unfinished != 1)
                return true;
            else if (BinService.getBin() === "Unfinished" && value.Status_Unfinished == 1)
                return true;
            else
                return false;
        },
        refresh: function(year)
        {
            this.counts = {};
            this.items = BinFactory.getApplications();
            if (typeof year !== "undefined")
                this.items =  $filter("filter")(this.items, {App_Fin_Year: year});

            this.calculateNewReturnCounts();
            this.calculateGradeCounts();
            this.calculateTaxStatusCounts();
            this.calculateTotalAwarded();
            this.calculateTotalRejected();
        },
        hasGrade: function(div) {
            for (var i in this.counts.grades) {
                if (this.counts.grades[i].code!==undefined) {
                    if (this.counts.grades[i].code.toString().substring(0, 2)==div) {
                        return true;
                    }
                }
            }
            return false;
        },
        calculateNewReturnCounts: function()
        {
            var parent = this;
            this.counts.newReturn = {};
            var faculty = authServiceFactory.getAuth().permissions.faculty;
            for (var i = 0; i < 3; i++)
                parent.counts.newReturn[i] = 0;
            for (var j = 0; j < this.items.length; j++) {
                if (this.inBin(this.items[j]) && !(faculty == 0 && this.items[j].isFaculty == 1)) {
                    parent.counts.newReturn[this.items[j].NR_Choice]++;
                }
            }
        },
        calculateGradeCounts: function()
        {
            var parent = this;
            this.counts.grades = [];
            var faculty = authServiceFactory.getAuth().permissions.faculty;
            angular.forEach(GradeSetupModelService.get(), function(grade) { //each grade
                if (parent.counts.grades[grade.DivisionCode]==undefined) {
                    parent.counts.grades[grade.DivisionCode] = {
                        "desc": grade.divisionDesc,
                        "code": grade.DivisionCode,
                        "del": grade.del,
                        "InUse": grade.InUse,
                        "order": parseInt(grade.questionOrder),
                        "count": 0
                    }
                }
            });
            angular.forEach(this.items, function(app) { //each application
                if (parent.inBin(app) && !(faculty===0 && app.isFaculty===1)) {
                    angular.forEach(app.Division_Code, function(value, key) { //each app division
                        if (parent.counts.grades[value]) {
                            parent.counts.grades[value].count++;
                        }
                    });
                }
            });
            parent.counts.grades = flattenObj(parent.counts.grades);
            BinService.setBin(BinService.getBin());
        },
        calculateTaxStatusCounts: function()
        {
            var parent = this;
            this.counts["taxStatus"] = {};
            parent.counts.taxStatus["not-received"] = 0;
            parent.counts.taxStatus["pending"] = 0;
            parent.counts.taxStatus["missing-information"] = 0;
            parent.counts.taxStatus["verified"] = 0;  
            var faculty = authServiceFactory.getAuth().permissions.faculty;
            angular.forEach(this.items, function(value, key) {
                if (parent.inBin(value)) {
                    if ((!(faculty===0 && value.isFaculty===1)))
                    {
                        parent.counts.taxStatus[value.taxStatusClass]++;
                    }
                }
            });
        },
        calculateTotalAwarded: function()
        {
            var applications = BinFactory.get(BinService.appFilter);
            var result = 0;
            for (var i = 0; i < applications.length; i++)
            {
                if (applications[i].Status_Award == 1) {
                    if (this.orObject(BinService.filter.gradeFilter.values)) {
                        for (let grade in BinService.filter.gradeFilter.values) {
                            if (BinService.filter.gradeFilter.values[grade]==true) {
                                for (var j = 0; j < applications[i].Division_Code.length; j++) {
                                    if (grade==applications[i].Division_Code[j]) {
                                        result += this.checkBudgets(applications, i, j);
                                    }
                                }
                            }
                        }
                    }
                    else {
                        result += this.checkBudgets(applications, i);
                    }
                }
            }
            return result;
        },
        checkBudgets: function(applications, i, j)
        {
            if (this.orObject(BinService.filter.accountsFilter.values)) {
                for (let budget in applications[i].budgets) {
                    for (let account in BinService.filter.accountsFilter.values)
                    if (budget==account && BinService.filter.accountsFilter.values[account]) {
                            return parseInt(applications[i].budgets[parseInt(budget)]);
                    }
                }
            }
            else {
                if (j==undefined)
                    return parseInt(applications[i].ActAward);
                else 
                    return parseInt(applications[i].ActAwards[j]);
            }
        },
        calculateTotalConsidered: function()
        {
            var applications = BinFactory.get();
            var result = 0;
            for (var i = 0; i < applications.length; i++)
            {
                if (applications[i].Status_Consider == 1)
                    if (this.checkBudgets(applications, i) == 0) {
                        result += applications[i].ConsiderAward ? parseInt(applications[i].ConsiderAward) : 0;
                    }
                    else {
                        result += this.checkBudgets(applications, i);
                    }
            }
            return result;
        },
        calculateTotalRejected: function()
        {
            var parent = this;
            this.counts["rejected"] = {};
            parent.counts.rejected["reject"] = 0;
            parent.counts.rejected["noaward"] = 0;
            angular.forEach(this.items, function(value, key) {
                if (BinService.getBin() === "Non-Awarded") {
                    if (value.Status_Award == 1 && value.ActAward == 0) {
                        parent.counts.rejected["noaward"]++;
                    }
                    else if (value.Status_Reject == 1) {
                        parent.counts.rejected["reject"]++;
                    }
                }
            });
        },
        getCounts: function()
        {
            return this.counts;
        },
        orObject: function(obj) {
            let sum = false;
            for (let el in obj) {
                sum = sum || obj[el];
            }
            return sum;
        }

    };
});
